import { TProject } from '../../types/TProject';

const PROJECTS: TProject[] = [
  {
    title: 'Numele proiectului',
    content:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    excerpt:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ',
    featured_image: '',
    id: 1,
    thumbnail_url: 'asdasdasd',
    created_at: '',
    dates: { start_date: '', end_date: '' },
    link: '/proiecte/1',
    exhibits: [
      {
        name: 'Sbornic',
        documents: [
          {
            name: 'Descriere',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/Sbornic-Descriere.doc',
          },
          {
            name: 'Fișă științifică nr. inv. 4573',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/Fisa-stiintifica-nr.inv_.4573-Sbornic.doc',
          },
          {
            name: 'Nr. inv. 457',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/nr.inv_.457-Sbornic.doc',
          },
          {
            name: 'Scor conservare',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/Sbornic-scor-conservare.doc',
          },
          {
            name: 'Hârtie manuală - Scor conservare - 3',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/hartie-manuala-SCOR_CONSERVARE-3-scaled.jpg',
          },
          {
            name: 'Nr. inv. 4573',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/4573-Sbornic-scaled.jpg',
          },
          {
            name: 'Nr. inv. 457',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/4573-scaled.jpg',
          },
        ],
      },
      {
        name: 'Nr.inv. 4654, f. 76',
        documents: [
          {
            name: 'Descriere',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/nr.inv_.4654-descriere.doc',
          },
          {
            name: 'Fișă științifică 4654 f. 76',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/Fisa-stiintifica-4654-f-76.doc',
          },
          {
            name: 'Situația cărților',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/nr.inv_.4654-Situatia-cartilor-.doc',
          },
          {
            name: 'Situația cărților - Sat Sebeș',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/nr.inv_.4654-Situatia-cartilor-Sat-Sebes.doc',
          },
          {
            name: 'Hârtie manuală - Scor conservare - 3',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/hartie-manuala-SCOR-CONSERVARE-–-3-scaled.jpg',
          },
          {
            name: 'Interior',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/4654-interior-scaled.jpg',
          },
          {
            name: 'Exterior',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/4654-exterior-scaled.jpg',
          },
        ],
      },
      {
        name: 'Nr.inv. 4654, f. 39-40',
        documents: [
          {
            name: 'Descriere',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/4654-f-40-descriere.doc',
          },
          {
            name: 'Fișă științifică 4654 - Ordin circular',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/Fisa-stiintifica-4654-Ordin-circular.doc',
          },
          {
            name: 'Scor conservare',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/4654-f40-scor-conservare.doc',
          },
          {
            name: 'Ordin circular',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/4654-f40-Ordin-circular.doc',
          },
          {
            name: 'Hârtie manuală - Scor conservare - 3',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/hartie-manuala-SCOR-CONSERVARE-–-3-1-scaled.jpg',
          },
          {
            name: 'Interior',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/4654-fila-40-scaled.jpg',
          },
          {
            name: 'Exterior',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/4654-f40-ext.jpg',
          },
        ],
      },
      {
        name: 'Nr.inv. 4652',
        documents: [
          {
            name: 'Descriere',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/nr.inv_.-4652-descriere.doc',
          },
          {
            name: 'Fișă științifică',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/Fisa-stiintifica-4652.doc',
          },
          {
            name: 'Scor conservare',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/4652-scor-de-conservare-.doc',
          },
          {
            name: 'Adresă',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/nr.inv-4652-Adresa.doc',
          },
          {
            name: '3F4652 din 1821',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/3F4652-din-1821-poza5-scaled.jpg',
          },
          {
            name: 'Interior',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/4652-interior-scaled.jpg',
          },
          {
            name: 'Exterior',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/4652-exterior-scaled.jpg',
          },
        ],
      },
      {
        name: 'Nr.inv. 4651, f. 6',
        documents: [
          {
            name: 'Descriere',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/Nr.inv-4651-fila-6-descriere.doc',
          },
          {
            name: 'Fișă științifică',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/fisa-descriere-document-4651-fila-6.doc',
          },
          {
            name: 'Scor conservare',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/4651-fila-6-sscor-conservare.doc',
          },
          {
            name: 'Ordonanță militară și administrativă din Orlat către toate școlile de grăniceri',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/Ordonanta-militara-si-administrativa-din-Orlat-catre-toate-scolile-de-graniceri-de-pe-teritoriul-Regimentului-I-romanesc-de-granita.doc',
          },
          {
            name: 'Hârtie manuală - Scor conservare - 2',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/hartie-manuala-SCOR-CONSERVARE-–-2-scaled.jpg',
          },
          {
            name: 'Interior',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/4651-fila-6-interior-scaled.jpg',
          },
          {
            name: 'Exterior',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/4651-scaled.jpg',
          },
        ],
      },
      {
        name: 'Nr.inv. 4651',
        documents: [
          {
            name: 'Descriere',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/nr.inv_.-4651-fila-40-descriere.doc',
          },
          {
            name: 'Fișă științifică',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/Fisa-stiintifica-nr.inv_.-4651.doc',
          },
          {
            name: 'Scor conservare',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/nr.inv_.-4651-fila-40.doc',
          },
          {
            name: 'Înștiințare',
            type: 'txt',
            url: 'https://cetateafagarasului.com/wp-content/uploads/nr.inv_.-4651-fila-40-Instintare.doc',
          },
          {
            name: 'Hârtie manuală - Scor conservare - 2',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/hartie-manuala-SCOR-CONSERVARE-–-2-1-scaled.jpg',
          },
          {
            name: 'Interior',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/4651-fila-40-interior-scaled.jpg',
          },
          {
            name: 'Exterior',
            type: 'img',
            url: 'https://cetateafagarasului.com/wp-content/uploads/4651-fila-40-exterior-scaled.jpg',
          },
        ],
      },
    ],
  },
];

export default PROJECTS;
